const common = {
  black: '#000',
  white: '#fff'
};
export default common;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/colors/common.js
// module id = 714
// module chunks = 22